<template>
  <el-dialog
    title="项目诊断 - 重复投放建议"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div v-loading="loading">
      <template v-if="diagnosisList.length > 0">
        <div v-for="(item, index) in diagnosisList" :key="index" class="diagnosis-item">
          <div class="diagnosis-reason">{{ item.reason }}</div>
        </div>
      </template>
      <template v-else-if="!loading">
        <div class="diagnosis-empty">
          <span>暂无重复投放建议</span>
        </div>
      </template>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="diagnosing" @click="onReDiagnose">重新诊断</el-button>
      <el-button @click="onClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { executeProjectDiagnosis, queryProjectDiagnosis } from '@/api/convert.model.js'

// eslint-disable-next-line
const props = defineProps({
  value: { type: Boolean, default: false },
  accountId: { type: [Number, String], default: null },
  projectIds: { type: Array, default: () => [] }
})

// eslint-disable-next-line
const emit = defineEmits(['input', 'refresh'])

const dialogVisible = computed({
  get: () => props.value,
  set: (val) => emit('input', val)
})

const loading = ref(false)
const diagnosing = ref(false)
const diagnosisList = ref([])

// 查询已有诊断结果
const loadDiagnosisResults = async () => {
  if (!props.accountId || !props.projectIds.length) return
  loading.value = true
  try {
    const res = await queryProjectDiagnosis({
      accountId: props.accountId,
      projectIds: JSON.stringify(props.projectIds)
    })
    if (res && Array.isArray(res)) {
      diagnosisList.value = res
    }
  } catch (e) {
    console.error('查询诊断结果失败', e)
  } finally {
    loading.value = false
  }
}

// 重新诊断
const onReDiagnose = async () => {
  if (!props.accountId || !props.projectIds.length) return
  diagnosing.value = true
  try {
    const res = await executeProjectDiagnosis({
      accountId: props.accountId,
      projectIds: JSON.stringify(props.projectIds)
    })
    if (res && Array.isArray(res)) {
      diagnosisList.value = res
      emit('refresh')
    }
  } catch (e) {
    console.error('执行诊断失败', e)
  } finally {
    diagnosing.value = false
  }
}

const onClose = () => {
  dialogVisible.value = false
}

// 弹窗打开时自动加载已有诊断结果
watch(
  () => props.value,
  (newVal) => {
    if (newVal) {
      loadDiagnosisResults()
    }
  }
)
</script>

<style lang="scss" scoped>
.diagnosis-item {
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: none;
  }
}

.diagnosis-reason {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  word-break: break-all;
}

.diagnosis-empty {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}
</style>
